const LogoMad = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        /*    xmlns:xlink="http://www.w3.org/1999/xlink" */
        width="274.181"
        height="50.513"
        viewBox="0 0 274.181 50.513"
      >
        <defs>
          <clipPath id="clip-path">
            <path
              id="Tracciato_10"
              data-name="Tracciato 10"
              d="M0,17.83H274.181V-32.683H0Z"
              transform="translate(0 32.683)"
              fill="none"
            />
          </clipPath>
        </defs>
        <g
          id="Raggruppa_12"
          data-name="Raggruppa 12"
          transform="translate(0 32.683)"
        >
          <g
            id="Raggruppa_10"
            data-name="Raggruppa 10"
            transform="translate(0 -32.683)"
            clip-path="url(#clip-path)"
          >
            <g
              id="Raggruppa_1"
              data-name="Raggruppa 1"
              transform="translate(0 0)"
            >
              <path
                id="Tracciato_1"
                data-name="Tracciato 1"
                d="M7.138,14.277A20.227,20.227,0,0,0,27.362-5.946,20.227,20.227,0,0,0,7.138-26.171,20.226,20.226,0,0,0-13.085-5.946,20.226,20.226,0,0,0,7.138,14.277"
                transform="translate(13.085 26.171)"
                fill="#d8000f"
              />
            </g>
            <g
              id="Raggruppa_2"
              data-name="Raggruppa 2"
              transform="translate(0.449 9.693)"
            >
              <path
                id="Tracciato_2"
                data-name="Tracciato 2"
                d="M.882,0l9.383.1c2.459.243,3.182,1.9,3.162,4.207L10.061,20.931H1.851L4.656,6.514l-6.273-.1A28.846,28.846,0,0,1,.882,0"
                transform="translate(1.617)"
                fill="#fff"
              />
            </g>
            <g
              id="Raggruppa_3"
              data-name="Raggruppa 3"
              transform="translate(0.449 9.693)"
            >
              <path
                id="Tracciato_3"
                data-name="Tracciato 3"
                d="M.882,0l9.383.1c2.459.243,3.182,1.9,3.162,4.207L10.061,20.931H1.851L4.656,6.514l-6.273-.1A28.846,28.846,0,0,1,.882,0Z"
                transform="translate(1.617)"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="22.926"
                stroke-width="0.219"
              />
            </g>
            <g
              id="Raggruppa_4"
              data-name="Raggruppa 4"
              transform="translate(13.856 9.625)"
            >
              <path
                id="Tracciato_4"
                data-name="Tracciato 4"
                d="M1.5.017-2.756,21.07H5.57L9.112,3.8c-.073-1.89-.9-3.343-3.4-3.828Z"
                transform="translate(2.756 0.031)"
                fill="#fff"
              />
            </g>
            <g
              id="Raggruppa_5"
              data-name="Raggruppa 5"
              transform="translate(24.076 9.726)"
            >
              <path
                id="Tracciato_5"
                data-name="Tracciato 5"
                d="M1.5,0-2.744,20.9H10.685a21.243,21.243,0,0,0,2.451-6.3l-6.267-.142L8.9,4.171C9.036,2.227,8.314.678,5.692,0Z"
                transform="translate(2.744)"
                fill="#fff"
              />
            </g>
            <g
              id="Raggruppa_6"
              data-name="Raggruppa 6"
              transform="translate(24.076 9.726)"
            >
              <path
                id="Tracciato_6"
                data-name="Tracciato 6"
                d="M1.5,0-2.744,20.9H10.685a21.243,21.243,0,0,0,2.451-6.3l-6.267-.142L8.9,4.171C9.036,2.227,8.314.678,5.692,0Z"
                transform="translate(2.744)"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="22.926"
                stroke-width="0.219"
              />
            </g>
            <g
              id="Raggruppa_7"
              data-name="Raggruppa 7"
              transform="translate(265.515 1.088)"
            >
              <path
                id="Tracciato_7"
                data-name="Tracciato 7"
                d="M1.533,0a4.309,4.309,0,1,1,0,8.618A4.309,4.309,0,1,1,1.533,0m0,7.984a3.554,3.554,0,0,0,3.538-3.7,3.551,3.551,0,1,0-7.1,0,3.56,3.56,0,0,0,3.561,3.7m-1.682-6.2H1.8c1.2,0,1.762.471,1.762,1.439A1.3,1.3,0,0,1,2.237,4.6L3.677,6.82H2.836L1.464,4.655H.636V6.82H-.148ZM.636,4.021h.818c.691,0,1.325-.036,1.325-.83,0-.668-.575-.771-1.105-.771H.636Z"
                transform="translate(2.811)"
                fill="#d8000f"
              />
            </g>
            <g
              id="Raggruppa_8"
              data-name="Raggruppa 8"
              transform="translate(57.591 41.231)"
            >
              <path
                id="Tracciato_8"
                data-name="Tracciato 8"
                d="M72.831,2.968H67.916V-.579h4.821v-.7H67.916V-4.6h4.915v-.7H67.149V3.665h5.681Zm-13.055.1a2.428,2.428,0,0,0,.765-1.779,2.213,2.213,0,0,0-.3-1.176,2.075,2.075,0,0,0-.771-.759,6.131,6.131,0,0,0-1.048-.464c-.38-.131-.76-.246-1.142-.349s-.729-.215-1.046-.335a1.941,1.941,0,0,1-.773-.512,1.141,1.141,0,0,1-.3-.784,1.442,1.442,0,0,1,.6-1.19,2.374,2.374,0,0,1,1.5-.464,3.156,3.156,0,0,1,2.566,1.128l.512-.564A3.841,3.841,0,0,0,57.3-5.44a3.313,3.313,0,0,0-2.1.657,2.089,2.089,0,0,0-.845,1.733,1.947,1.947,0,0,0,.3,1.082,2.06,2.06,0,0,0,.773.7,6.591,6.591,0,0,0,1.048.428c.382.122.76.236,1.142.345a8.6,8.6,0,0,1,1.046.362,1.905,1.905,0,0,1,.773.572,1.4,1.4,0,0,1,.3.906,1.692,1.692,0,0,1-.558,1.243,2.523,2.523,0,0,1-1.807.542,3.529,3.529,0,0,1-2.794-1.3l-.5.576a4.008,4.008,0,0,0,3.278,1.423,3.33,3.33,0,0,0,2.419-.759m-12.2-8.361h-.765V3.666h.765Zm-10.048.7h2.929v-.7H33.824v.7h2.927V3.665h.779ZM22.622-.74V-4.6h2.511a1.978,1.978,0,0,1,1.437.538,1.849,1.849,0,0,1,.55,1.385,1.869,1.869,0,0,1-.55,1.389,1.963,1.963,0,0,1-1.437.544ZM25.443-.1A2.625,2.625,0,0,0,27.209-.82a2.446,2.446,0,0,0,.719-1.853,2.462,2.462,0,0,0-.774-1.907A2.767,2.767,0,0,0,25.2-5.293H21.856V3.665h.767V-.041H24.6l2.513,3.706h.926ZM15.194,2.968H10.278V-.579H15.1v-.7H10.278V-4.6h4.916v-.7H9.512V3.665h5.683ZM-2.16-.754V-4.6H.351a1.95,1.95,0,0,1,1.43.538,1.863,1.863,0,0,1,.546,1.385A1.864,1.864,0,0,1,1.781-1.29a1.943,1.943,0,0,1-1.43.536Zm0,.7H.433A2.6,2.6,0,0,0,2.4-.814a2.579,2.579,0,0,0,.731-1.859,2.6,2.6,0,0,0-.725-1.862A2.6,2.6,0,0,0,.433-5.293H-2.925V3.665h.765Zm-10.5-.887,3.4-4.352h-.968l-2.915,3.8-2.9-3.8h-.981l3.413,4.365-3.613,4.593h.966l3.117-4.042,3.13,4.042h.954Zm-9.4,3.909h-4.916V-.579h4.822v-.7h-4.822V-4.6h4.916v-.7H-27.75V3.665h5.681ZM-38.9,2.349V-.78h-4.15V-.1h3.385v2.15a3.972,3.972,0,0,1-1.128.765,3.487,3.487,0,0,1-1.5.323,3.545,3.545,0,0,1-2.668-1.114A3.942,3.942,0,0,1-46.029-.808a3.9,3.9,0,0,1,1.068-2.833,3.562,3.562,0,0,1,2.668-1.1,3.714,3.714,0,0,1,1.578.337,3.417,3.417,0,0,1,1.215.912l.58-.416a4.274,4.274,0,0,0-3.372-1.53,4.417,4.417,0,0,0-3.232,1.3A4.5,4.5,0,0,0-46.834-.808a4.523,4.523,0,0,0,1.309,3.346,4.412,4.412,0,0,0,3.232,1.3,4.35,4.35,0,0,0,3.4-1.491M-53.5-5.293h-.765V2.3l-5.615-7.589h-.779V3.665h.767v-7.7l5.641,7.7h.751Zm-14.157,0h-.765V3.666h.765ZM-80.4-.74V-4.6h2.511a1.976,1.976,0,0,1,1.437.538,1.855,1.855,0,0,1,.55,1.385,1.875,1.875,0,0,1-.55,1.389,1.961,1.961,0,0,1-1.437.544Zm2.821.644A2.628,2.628,0,0,0-75.813-.82a2.44,2.44,0,0,0,.719-1.853,2.466,2.466,0,0,0-.773-1.907,2.77,2.77,0,0,0-1.954-.712h-3.346V3.665h.767V-.041h1.974l2.511,3.706h.927Zm-10.25,3.063h-4.915V-.579h4.822v-.7h-4.822V-4.6h4.915v-.7h-5.68V3.665h5.68ZM-102.792-4.6h2.929v-.7H-106.5v.7h2.929V3.665h.779Zm-9.724,7.564h-4.916V-.579h4.822v-.7h-4.822V-4.6h4.916v-.7H-118.2V3.665h5.681Zm-12.605-8.261h-1.155l-3.035,7.388-3.049-7.388H-133.5V3.665h.767v-7.91l3.277,7.91h.3l3.264-7.91v7.91h.777Z"
                transform="translate(133.503 5.44)"
                fill="#2b2e34"
              />
            </g>
            <g
              id="Raggruppa_9"
              data-name="Raggruppa 9"
              transform="translate(57.591 0.946)"
            >
              <path
                id="Tracciato_9"
                data-name="Tracciato 9"
                d="M66.522,5.082,68.06-.543c1.436-.287,2.785-.5,4.04-.635a30.953,30.953,0,0,1,3.448-.209q4.831,0,6.837,1.7t2.008,5.771V20.435h-7.65V18.019a10.487,10.487,0,0,1-2.753,1.751,7.266,7.266,0,0,1-2.83.57,6.776,6.776,0,0,1-5.066-2.034,7.184,7.184,0,0,1-1.988-5.239,6.41,6.41,0,0,1,2.054-4.946,7.571,7.571,0,0,1,5.355-1.9,8.392,8.392,0,0,1,2.468.365A8.9,8.9,0,0,1,76.312,7.7V6.5a2.18,2.18,0,0,0-.926-1.946,5.114,5.114,0,0,0-2.865-.632,13.846,13.846,0,0,0-2.675.289,28.909,28.909,0,0,0-3.323.872m6.04,7.791a1.894,1.894,0,0,0,.51,1.4,2,2,0,0,0,2.729-.025,1.886,1.886,0,0,0,.552-1.376,1.807,1.807,0,0,0-1.907-1.912,1.82,1.82,0,0,0-1.362.522,1.872,1.872,0,0,0-.522,1.389M42.488,20.435v-21.7h7.488V1.505a6.887,6.887,0,0,1,2.45-2.182,6.869,6.869,0,0,1,3.193-.709A5.2,5.2,0,0,1,60,.433q1.421,1.82,1.416,5.616V20.435H53.358V7.7A1.967,1.967,0,0,0,53,6.451a1.231,1.231,0,0,0-1.022-.442,1.2,1.2,0,0,0-1,.442A1.967,1.967,0,0,0,50.627,7.7V20.435ZM40.595,17.57a15.087,15.087,0,0,1-4.422,2.321,16.358,16.358,0,0,1-5.032.745,11.452,11.452,0,0,1-8.307-3.066A10.584,10.584,0,0,1,19.66,9.605,10.443,10.443,0,0,1,22.847,1.7a11.481,11.481,0,0,1,8.293-3.046A10.331,10.331,0,0,1,36.811.238,12.366,12.366,0,0,1,40.99,4.961L30.376,13.106a6.879,6.879,0,0,0,.971.27,4.89,4.89,0,0,0,.912.087,5.966,5.966,0,0,0,2.236-.47,11.944,11.944,0,0,0,2.564-1.5ZM27.626,9.686l5.326-4.034a3.539,3.539,0,0,0-1.014-.671,2.978,2.978,0,0,0-1.127-.215,3.409,3.409,0,0,0-2.556.954,3.53,3.53,0,0,0-.947,2.59,2.913,2.913,0,0,0,.082.675,3.561,3.561,0,0,0,.236.7M16.713,20.435H8.594V-9.315h8.119ZM-13.195,5.082l1.539-5.624c1.433-.287,2.782-.5,4.037-.635a31,31,0,0,1,3.45-.209q4.829,0,6.837,1.7T4.675,6.082V20.435h-7.65V18.019A10.442,10.442,0,0,1-5.724,19.77a7.294,7.294,0,0,1-2.835.57,6.768,6.768,0,0,1-5.065-2.034,7.192,7.192,0,0,1-1.989-5.239,6.42,6.42,0,0,1,2.054-4.946A7.578,7.578,0,0,1-8.2,6.221a8.413,8.413,0,0,1,2.471.365A8.991,8.991,0,0,1-3.4,7.7V6.5a2.184,2.184,0,0,0-.926-1.946,5.125,5.125,0,0,0-2.865-.632,13.876,13.876,0,0,0-2.678.289,28.81,28.81,0,0,0-3.321.872m6.038,7.791a1.907,1.907,0,0,0,.51,1.4,1.831,1.831,0,0,0,1.377.525,1.834,1.834,0,0,0,1.355-.55,1.883,1.883,0,0,0,.549-1.376,1.87,1.87,0,0,0-.529-1.389,1.877,1.877,0,0,0-1.376-.522,1.826,1.826,0,0,0-1.363.522,1.873,1.873,0,0,0-.524,1.389M-18.313-9.315v29.75h-7.669l.019-2.341a7.905,7.905,0,0,1-2.624,1.751,8.593,8.593,0,0,1-3.253.59,8.676,8.676,0,0,1-6.8-3A11.28,11.28,0,0,1-41.3,9.678a11.147,11.147,0,0,1,2.732-7.783,9.1,9.1,0,0,1,7.058-3.006,9.238,9.238,0,0,1,2.92.422A5.654,5.654,0,0,1-26.435.58V-9.315Zm-8.122,18.92a3.269,3.269,0,0,0-.892-2.389A3.115,3.115,0,0,0-29.661,6.3a3.145,3.145,0,0,0-2.355.927,3.24,3.24,0,0,0-.906,2.375,3.242,3.242,0,0,0,.906,2.374,3.151,3.151,0,0,0,2.355.927,3.1,3.1,0,0,0,2.334-.927,3.257,3.257,0,0,0,.892-2.374M-43.77-9.315v29.75h-7.638V18.094a7.921,7.921,0,0,1-2.624,1.751,8.6,8.6,0,0,1-3.255.59,8.678,8.678,0,0,1-6.8-3,11.286,11.286,0,0,1-2.651-7.757A11.146,11.146,0,0,1-64.01,1.895a9.1,9.1,0,0,1,7.058-3.006,9.244,9.244,0,0,1,2.92.422A5.684,5.684,0,0,1-51.878.58V-9.315Zm-8.108,18.92a3.276,3.276,0,0,0-.893-2.389A3.121,3.121,0,0,0-55.106,6.3a3.148,3.148,0,0,0-2.355.927,3.24,3.24,0,0,0-.906,2.375,3.241,3.241,0,0,0,.906,2.374,3.154,3.154,0,0,0,2.355.927,3.108,3.108,0,0,0,2.335-.927,3.264,3.264,0,0,0,.893-2.374m-35.2-4.524,1.538-5.624c1.436-.287,2.785-.5,4.038-.635a31.023,31.023,0,0,1,3.45-.209q4.831,0,6.837,1.7T-69.2,6.082V20.435h-7.649V18.019A10.456,10.456,0,0,1-79.6,19.77a7.274,7.274,0,0,1-2.831.57A6.773,6.773,0,0,1-87.5,18.307a7.191,7.191,0,0,1-1.988-5.239,6.415,6.415,0,0,1,2.054-4.946,7.571,7.571,0,0,1,5.355-1.9,8.385,8.385,0,0,1,2.468.365A8.914,8.914,0,0,1-77.283,7.7V6.5a2.184,2.184,0,0,0-.926-1.946,5.114,5.114,0,0,0-2.865-.632,13.888,13.888,0,0,0-2.678.289,28.975,28.975,0,0,0-3.321.872m6.04,7.791a1.894,1.894,0,0,0,.51,1.4,1.83,1.83,0,0,0,1.376.525,1.837,1.837,0,0,0,1.355-.55,1.891,1.891,0,0,0,.55-1.376,1.871,1.871,0,0,0-.53-1.389,1.874,1.874,0,0,0-1.376-.522,1.82,1.82,0,0,0-1.362.522,1.867,1.867,0,0,0-.524,1.389m-40.906,7.562v-21.7h7.448V1.779a7.588,7.588,0,0,1,2.6-2.4,6.947,6.947,0,0,1,3.355-.819,6.018,6.018,0,0,1,2.59.559,7.11,7.11,0,0,1,2.207,1.7,6.6,6.6,0,0,1,2.261-1.7,7.066,7.066,0,0,1,2.886-.559A5.955,5.955,0,0,1-93.8.493a8.311,8.311,0,0,1,1.665,5.556V20.435h-8.14V7.7a1.958,1.958,0,0,0-.355-1.247,1.224,1.224,0,0,0-1.02-.442,1.2,1.2,0,0,0-1,.442A1.958,1.958,0,0,0-103.01,7.7V20.435h-8.058V7.7a1.958,1.958,0,0,0-.357-1.247,1.221,1.221,0,0,0-1.018-.442,1.2,1.2,0,0,0-1,.442A1.958,1.958,0,0,0-113.8,7.7V20.435Z"
                transform="translate(121.94 9.315)"
                fill="#d8000f"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};
export default LogoMad;
